import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3 {...{
      "id": "b2b-245-246-class"
    }}>{`Class changes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`What changed`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`How it changed`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\AdobeCommerceEventsClient\\Block\\Events\\EventPayload`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\AdobeCommerceEventsClient\\Block\\Events\\ModuleList`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Backend\\Console\\Command\\AbstractCacheTypeManageCommand::execute`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Method return typing changed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Backend\\Model\\Auth\\Session::getAcl`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Backend\\Model\\Auth\\Session::setAcl`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\CustomerSegment\\Model\\Customer::XML`}{`_`}{`PATH`}{`_`}{`REAL`}{`_`}{`TIME`}{`_`}{`CHECK`}{`_`}{`IF`}{`_`}{`CUSTOMER`}{`_`}{`IS`}{`_`}{`MATCHED`}{`_`}{`BY`}{`_`}{`SEGMENT`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Constant has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Filter\\FilterManager::`}{`_`}{`_`}{`call`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method return typing changed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Filter\\FilterManager::createFilterInstance`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Method return typing changed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Filter\\FilterManager::get`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method return typing changed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Filter\\Template`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Implements has been removed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Filter\\Template`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Exception\\GraphQlAuthenticationException`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Exception\\GraphQlAuthenticationException::getExtensions`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Exception\\GraphQlAuthorizationException`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Exception\\GraphQlAuthorizationException::getExtensions`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Exception\\GraphQlInputException`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Exception\\GraphQlInputException::getExtensions`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\HTTP\\Adapter\\Curl`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Implements has been removed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\HTTP\\Adapter\\Curl`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\HTTP\\Adapter\\Curl::$`}{`_`}{`options`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been removed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\HTTP\\Adapter\\Curl::setOptions`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method parameter typing removed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Model\\AbstractModel::`}{`_`}{`createValidatorBeforeSave`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Method return typing changed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Model\\AbstractModel::`}{`_`}{`getValidationRulesBeforeSave`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Method return typing changed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Model\\AbstractModel::`}{`_`}{`getValidatorBeforeSave`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Method return typing changed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Stdlib\\DateTime\\Filter\\Date`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Implements has been removed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Stdlib\\DateTime\\Filter\\Date`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Validator::setTranslator`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method parameter typing added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Validator\\AbstractValidator::getDefaultTranslator`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method return typing changed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Validator\\AbstractValidator::getTranslator`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method return typing changed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Validator\\AbstractValidator::setDefaultTranslator`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method parameter typing changed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Validator\\AbstractValidator::setTranslator`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method parameter typing added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Validator\\Constraint::getTranslator`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method return typing changed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Validator\\Constraint::setTranslator`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method parameter typing added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Validator\\DataObject`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Implements has been removed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Validator\\DataObject`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Validator\\DataObject::addRule`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method parameter typing changed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\GoogleAdwords\\Model\\Config\\Backend\\Color::`}{`_`}{`getValidationRulesBeforeSave`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Method return typing changed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\GoogleAdwords\\Model\\Config\\Backend\\ConversionId::`}{`_`}{`getValidationRulesBeforeSave`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Method return typing changed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\GoogleAdwords\\Model\\Filter\\UppercaseTitle`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Implements has been removed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\GoogleAdwords\\Model\\Filter\\UppercaseTitle`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ImportExport\\Model\\Import::FIELD`}{`_`}{`IMPORT`}{`_`}{`IDS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Constant has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ImportExport\\Model\\Import::`}{`_`}{`getEntityAdapter`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Method return typing changed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ImportExport\\Model\\Import::getValidatedIds`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ImportExport\\Model\\Import\\AbstractEntity`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ImportExport\\Model\\Import\\AbstractEntity::getDataSourceModel`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ImportExport\\Model\\Import\\AbstractEntity::getIds`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ImportExport\\Model\\Import\\AbstractEntity::setIds`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ImportExport\\Model\\Import\\Entity\\AbstractEntity`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ImportExport\\Model\\Import\\Entity\\AbstractEntity::getDataSourceModel`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ImportExport\\Model\\Import\\Entity\\AbstractEntity::getIds`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ImportExport\\Model\\Import\\Entity\\AbstractEntity::setIds`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ImportExport\\Model\\ResourceModel\\Import\\Data::cleanProcessedBunches`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ImportExport\\Model\\ResourceModel\\Import\\Data::getBehavior`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Added optional parameter(s).`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ImportExport\\Model\\ResourceModel\\Import\\Data::getEntityTypeCode`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Added optional parameter(s).`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ImportExport\\Model\\ResourceModel\\Import\\Data::getIteratorForCustomQuery`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ImportExport\\Model\\ResourceModel\\Import\\Data::getNextUniqueBunch`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ImportExport\\Model\\ResourceModel\\Import\\Data::getUniqueColumnDataWithIds`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ImportExport\\Model\\ResourceModel\\Import\\Data::markProcessedBunches`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\MediaStorage\\Model\\File\\Uploader::renameFile`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Payment\\Gateway\\Http\\Client\\Zend::`}{`_`}{`_`}{`construct`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method parameter typing changed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Payment\\Model\\Method\\Free::$`}{`_`}{`isOffline`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\QuickCheckoutAdminPanel\\Block\\Adminhtml\\Index`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\QuickCheckout\\Block\\Adminhtml\\Payment\\Form`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\QuickCheckout\\Block\\Adminhtml\\System\\Config\\ConfigureCallbackUrl`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\QuickCheckout\\Block\\Adminhtml\\System\\Config\\Fieldset\\Custom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\QuickCheckout\\Block\\Adminhtml\\System\\Config\\Fieldset\\Head`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\QuickCheckout\\Block\\Adminhtml\\System\\Config\\ValidateCredentials`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\QuickCheckout\\Block\\Sdk`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Quote\\Model\\Quote\\Address\\Rate::$carrier`}{`_`}{`sort`}{`_`}{`order`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\SalesRule\\Model\\ResourceModel\\Rule\\Collection::$`}{`_`}{`eventObject`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\SalesRule\\Model\\ResourceModel\\Rule\\Collection::$`}{`_`}{`eventPrefix`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Property has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Store\\Model\\Store::`}{`_`}{`getValidationRulesBeforeSave`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Method return typing changed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Theme\\Block\\Html\\Topmenu::getCacheTags`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Method has been removed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\User\\Model\\ResourceModel\\User::getValidationRulesBeforeSave`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method return typing changed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\User\\Model\\User::`}{`_`}{`getValidationRulesBeforeSave`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Method return typing changed.`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "b2b-245-246-interface"
    }}>{`Interface changes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`What changed`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`How it changed`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\AdobeImsApi\\Api\\ConfigInterface::getLogoutUrl`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method parameter name changed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Filter\\FactoryInterface::createFilter`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method return typing changed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Translate\\AdapterInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Added parent to interface.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Translate\\AdapterInterface::translate`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Added optional parameter(s).`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Validator\\ValidatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Added parent to interface.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Validator\\ValidatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Extends has been removed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Validator\\ValidatorInterface::getTranslator`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method return typing changed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Validator\\ValidatorInterface::setTranslator`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method parameter typing added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ImportCsvApi\\Api\\Data\\SourceDataInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ImportCsvApi\\Api\\StartImportInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ImportExport\\Model\\Import\\EntityInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\PurchaseOrderRule\\Api\\Data\\RuleInterface::getAppliesToRoleIds`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method return typing changed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\PurchaseOrderRule\\Api\\Data\\RuleInterface::getApproverRoleIds`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method return typing changed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\QuickCheckout\\Api\\AccountRepositoryInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\QuickCheckout\\Api\\Data\\AccountInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\QuickCheckout\\Api\\Data\\AddressInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\QuickCheckout\\Api\\Data\\PaymentMethodInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\QuickCheckout\\Api\\StorefrontAccountRepositoryInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "b2b-245-246-database"
    }}>{`Database changes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`What changed`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`How it changed`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`event`}{`_`}{`data`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Table was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`importexport`}{`_`}{`importdata/is`}{`_`}{`processed`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Column was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`importexport`}{`_`}{`importdata/updated`}{`_`}{`at`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Column was added`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "b2b-245-246-di"
    }}>{`Di changes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`What changed`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`How it changed`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Elasticsearch6\\Model\\Adapter\\FieldMapper\\ProductFieldMapper`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Virtual Type was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Elasticsearch6\\Model\\Client\\ElasticsearchFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Virtual Type was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Elasticsearch6\\Model\\DataProvider\\Suggestions`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Virtual Type was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Elasticsearch6\\Setup\\InstallConfig`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Virtual Type was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Elasticsearch\\Elasticsearch5\\SearchAdapter\\ConnectionManager`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Virtual Type was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`elasticsearch6FieldNameResolver`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Virtual Type was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Virtual Type was changed`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "b2b-245-246-system"
    }}>{`System changes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`What changed`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`How it changed`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`admin/grid`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`admin/grid/limit`}{`_`}{`total`}{`_`}{`number`}{`_`}{`of`}{`_`}{`products`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`admin/grid/records`}{`_`}{`limit`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`adobe`}{`_`}{`io`}{`_`}{`events`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A section-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`adobe`}{`_`}{`io`}{`_`}{`events/eventing`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`adobe`}{`_`}{`io`}{`_`}{`events/eventing/enabled`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`adobe`}{`_`}{`io`}{`_`}{`events/eventing/env`}{`_`}{`id`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`adobe`}{`_`}{`io`}{`_`}{`events/eventing/event`}{`_`}{`retention`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`adobe`}{`_`}{`io`}{`_`}{`events/eventing/max`}{`_`}{`retries`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`adobe`}{`_`}{`io`}{`_`}{`events/eventing/merchant`}{`_`}{`id`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`adobe`}{`_`}{`io`}{`_`}{`events/integration`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`adobe`}{`_`}{`io`}{`_`}{`events/integration/adobe`}{`_`}{`io`}{`_`}{`environment`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`adobe`}{`_`}{`io`}{`_`}{`events/integration/adobe`}{`_`}{`io`}{`_`}{`event`}{`_`}{`provider`}{`_`}{`metadata`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`adobe`}{`_`}{`io`}{`_`}{`events/integration/instance`}{`_`}{`id`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`adobe`}{`_`}{`io`}{`_`}{`events/integration/private`}{`_`}{`key`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`adobe`}{`_`}{`io`}{`_`}{`events/integration/provider`}{`_`}{`id`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`adobe`}{`_`}{`io`}{`_`}{`events/integration/workspace`}{`_`}{`configuration`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`catalog/magento`}{`_`}{`catalogpermissions/grant`}{`_`}{`catalog`}{`_`}{`category`}{`_`}{`view`}{`_`}{`groups`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`catalog/search/elasticsearch6`}{`_`}{`enable`}{`_`}{`auth`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`catalog/search/elasticsearch6`}{`_`}{`index`}{`_`}{`prefix`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`catalog/search/elasticsearch6`}{`_`}{`minimum`}{`_`}{`should`}{`_`}{`match`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`catalog/search/elasticsearch6`}{`_`}{`password`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`catalog/search/elasticsearch6`}{`_`}{`server`}{`_`}{`hostname`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`catalog/search/elasticsearch6`}{`_`}{`server`}{`_`}{`port`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`catalog/search/elasticsearch6`}{`_`}{`server`}{`_`}{`timeout`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`catalog/search/elasticsearch6`}{`_`}{`test`}{`_`}{`connect`}{`_`}{`wizard`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`catalog/search/elasticsearch6`}{`_`}{`username`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`catalog/search/opensearch`}{`_`}{`enable`}{`_`}{`auth`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`catalog/search/opensearch`}{`_`}{`index`}{`_`}{`prefix`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`catalog/search/opensearch`}{`_`}{`minimum`}{`_`}{`should`}{`_`}{`match`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`catalog/search/opensearch`}{`_`}{`password`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`catalog/search/opensearch`}{`_`}{`server`}{`_`}{`hostname`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`catalog/search/opensearch`}{`_`}{`server`}{`_`}{`port`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`catalog/search/opensearch`}{`_`}{`server`}{`_`}{`timeout`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`catalog/search/opensearch`}{`_`}{`test`}{`_`}{`connect`}{`_`}{`wizard`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`catalog/search/opensearch`}{`_`}{`username`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`checkout`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A section-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`checkout/quick`}{`_`}{`checkout`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`checkout/quick`}{`_`}{`checkout/credentials`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`checkout/quick`}{`_`}{`checkout/credentials/api`}{`_`}{`key`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`checkout/quick`}{`_`}{`checkout/credentials/configure`}{`_`}{`callback`}{`_`}{`url`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`checkout/quick`}{`_`}{`checkout/credentials/publishable`}{`_`}{`key`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`checkout/quick`}{`_`}{`checkout/credentials/signing`}{`_`}{`secret`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`checkout/quick`}{`_`}{`checkout/credentials/validate`}{`_`}{`credentials`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`checkout/quick`}{`_`}{`checkout/general`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`checkout/quick`}{`_`}{`checkout/general/active`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`checkout/quick`}{`_`}{`checkout/general/method`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`checkout/quick`}{`_`}{`checkout/settings`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`checkout/quick`}{`_`}{`checkout/settings/auto`}{`_`}{`login`}{`_`}{`network`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`checkout/quick`}{`_`}{`checkout/settings/checkout`}{`_`}{`tracking`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`checkout/quick`}{`_`}{`checkout/settings/debug`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`checkout/quick`}{`_`}{`checkout/settings/enable`}{`_`}{`auto`}{`_`}{`login`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`checkout/quick`}{`_`}{`checkout/settings/next`}{`_`}{`stage`}{`_`}{`after`}{`_`}{`login`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`checkout/quick`}{`_`}{`checkout/settings/payment`}{`_`}{`action`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`checkout/quick`}{`_`}{`checkout/settings/title`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`currency/fixerio`}{`_`}{`apilayer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`currency/fixerio`}{`_`}{`apilayer/api`}{`_`}{`key`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`currency/fixerio`}{`_`}{`apilayer/timeout`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`customer/account`}{`_`}{`information/confirm`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`customer/magento`}{`_`}{`customersegment/real`}{`_`}{`time`}{`_`}{`check`}{`_`}{`if`}{`_`}{`customer`}{`_`}{`is`}{`_`}{`matched`}{`_`}{`by`}{`_`}{`segment`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`system/smtp/auth`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`system/smtp/password`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`system/smtp/ssl`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`system/smtp/transport`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`system/smtp/username`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "b2b-245-246-xsd"
    }}>{`Xsd changes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`What changed`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`How it changed`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`app/code/module-adobe-commerce-events-client/etc/io`}{`_`}{`events.xsd`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A schema declaration was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`app/code/module-backend/etc/menu.xsd`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A schema declaration was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`app/code/module-backend/etc/menu.xsd`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A schema declaration was removed`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "b2b-245-246-class-api-membership"
    }}>{`Class API membership changes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`What changed`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`How it changed`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ImportExport\\Model\\AbstractModel`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\SalesRule\\Model\\Validator`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Block\\Adminhtml\\Order\\Create\\Form\\Address`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      